import { z } from "zod"

const jsonObjectSchema = z.record(z.string(), z.unknown())

export const stringArraySchema = z.array(z.string())

export const stringRecordSchema = z.record(z.string(), z.string())

const serializedCursorSchema = z.string().nullable().optional()

export const normalizeSerializedCursors = (
  cursors: ReadonlyArray<string | null | undefined>,
): (string | undefined)[] =>
  cursors.map((cursor) => (cursor === null ? undefined : cursor))

const peakPairSchema = z
  .tuple([
    z.number().finite().min(-1).max(1),
    z.number().finite().min(-1).max(1),
  ])
  .refine(([minimum, maximum]) => minimum <= maximum)
const peakChannelSchema = z.array(peakPairSchema).nonempty()
const MAX_PRECOMPUTED_CHANNELS = 2

export const peaksResponseSchema = z.union([
  peakChannelSchema,
  z
    .object({
      version: z.literal(2),
      duration_seconds: z.number().finite().positive(),
      channels: z
        .array(peakChannelSchema)
        .nonempty()
        .max(MAX_PRECOMPUTED_CHANNELS),
    })
    .refine(({ channels }) =>
      channels.every((channel) => channel.length === channels[0].length),
    ),
])

export const runsSessionStateSchema = z
  .object({
    loadedCursors: z.array(serializedCursorSchema),
    scrollOffset: z.number(),
    clickedRowId: z.string(),
    timestamp: z.number(),
    viewMode: z.string(),
  })
  .passthrough()

export const conversationsSessionStateSchema = z
  .object({
    loadedCursors: z.array(serializedCursorSchema),
    scrollOffset: z.number(),
    clickedRowId: z.string(),
    timestamp: z.number(),
    filters: jsonObjectSchema.optional(),
    selectedKeys: z.array(z.string()).optional(),
    selectedRunIdsBySimulationId: stringRecordSchema.optional(),
  })
  .passthrough()

export const savedViewStorageStateSchema = z
  .object({
    loadedViewId: z.string().nullable().optional(),
  })
  .passthrough()
